import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-notifications',
  templateUrl: './profile-notifications.component.html',
  styleUrls: ['./profile-notifications.component.scss']
})
export class ProfileNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
